import React, { useEffect, useState } from "react";
import BotResponseLayout from "./BotResponseLayout";
import { useDispatch, useSelector } from "react-redux";
import { GetEvents } from "../../../apis/api/EventsApi";
import { baseUrl } from "../../../apis/api/config";

function BotCurrentEventResponse({ actionProvider, currentOrPast }) {
  const { events } = useSelector(state => state.EventSlice);
  const [displayEvents, setDisplayEvents] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if(!events || events.length === 0){
        dispatch(GetEvents());
    }
  }, [dispatch])


  useEffect(() => {
    setDisplayEvents(events.filter(event => event.status === currentOrPast));

  }, [events])

  

  return (
    <BotResponseLayout actionProvider={actionProvider}>
      <div
        style={{
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: "12px",
          padding: "16px",
          maxWidth: "420px",
          fontFamily: "sans-serif",
        }}
      >
        <h2
          style={{
            fontSize: "20px",
            fontWeight: 600,
            color: "#1f2937",
            marginBottom: "12px",
          }}
        >
          {currentOrPast === "current" ? "Upcoming Events" : "Past Events"} 
        </h2>

        {displayEvents.slice(0, 3).map((event) => (
          <div
            key={event.id}
            style={{
              marginBottom: "12px",
              padding: "10px",
              borderRadius: "8px",
              backgroundColor: "#f9fafb",
              border: "1px solid #e5e7eb",
            }}
          >
            <h3
              style={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#111827",
                marginBottom: "6px",
              }}
            >
              {event.Event_Title}
            </h3>
            <p
              style={{
                fontSize: "14px",
                color: "#374151",
                margin: "2px 0",
              }}
            >
              📅 {(new Date(event.start_date * 1000)).toISOString().split('T')[0]}
            </p>
            <p
              style={{
                fontSize: "14px",
                color: "#374151",
                margin: "2px 0",
              }}
            >
              📍 {event.Location}
            </p>
          </div>
        ))}
        <a href={`/EventsMenu`} target="_blank">View all events</a>
      </div>
    </BotResponseLayout>
  );
}

export default BotCurrentEventResponse;
